import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { styled } from '@mui/material';

const ViewportFullScreenIcon = styled(OpenInFullIcon)`
    color: ${({ theme }) => theme.palette.text.primary};
    cursor: pointer;
    pointer-events: auto;
`;

interface SwapToFullScreenProps {
    showFullscreen: boolean;
    setShowFullscreen: (arg0: boolean) => void;
}

const SwapToFullScreen = ({
    showFullscreen,
    setShowFullscreen,
}: SwapToFullScreenProps) => {
    return (
        <ViewportFullScreenIcon
            onClick={() => setShowFullscreen(!showFullscreen)}
            data-testid="full-screen-toggle"
        />
    );
};

export default SwapToFullScreen;
